module.exports = __webpack_public_path__ + "form-background.5d043d1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/Booking/form-background.jpg
// module id = 610
// module chunks = 0